// Hot Topics
import HTAutonomousVehicle from "./pages/HT-AutonomousVehicle.js"
import HTAtFault from "./pages/HT-AtFault.js";
import HTContributingFactors from "./pages/HT-ContributingFactors.js";
import HTCrashInvestigation from "./pages/HT-CrashInvestigation.js";
import HTNarrative from "./pages/HT-Narrative.js";
import HTPrivatePropertyCrashes from "./pages/HT-PrivatePropertyCrashes.js";
import HTCommercialMotorVehicles from "./pages/HT-CommercialMotorVehicles.js";
import HTOccupantProtection from "./pages/HT-OccupantProtection.js";
import HTFatalCrash from "./pages/HT-FatalCrash.js";
import HTHitAndRun from "./pages/HT-HitAndRun.js";
import HTLocation from "./pages/HT-Location.js";

// Multi Topics
import CollisionDetails from "./pages/collision_details_and_circumstances.js";
import commercial_motor_vehicles from "./pages/commercial_motor_vehicles.js";
import contributing_factors from "./pages/contributing_factors.js";
import crash_location from "./pages/crash_location.js";
import crash_report_forms from "./pages/crash_report_forms.js";
import crash_specific_information from "@/pages/crash_specific_information.js";
import diagrams from "./pages/diagrams.js";
import executive_summary from "@/pages/executive_summary.js";
import location_identification_tips from "./pages/location_identification_tips.js";
import narrative from "./pages/Narrative.js";
import occupant_information from "./pages/occupant_information.js";
import overview from "./pages/overview.js";
import property_damage_witness_information from "./pages/property_damage_witness_information.js";
import reporting_fatal_crashes from "./pages/reporting_fatal_crashes.js";
import reporting_motor_vehicle_crashes_with_trains from "./pages/reporting_motor_vehicle_crashes_with_trains.js";
import roadway_details from "./pages/roadway_details.js";
import submitting_a_crash_report from "./pages/submitting_a_crash_report.js";
import unit_operator_details from "./pages/unit_operator_details.js";
import vehicle_details from "./pages/vehicle_details.js";
import data from "./pages/data.js";
import rules from "./pages/rules.js";
import contactus from "./pages/contactus.js";
import learning_module from "./pages/learning_module.js";
import faq from "./pages/faq.js";

// Lists and Tables
import county_list from "./pages/county_list";
import glossary from "@/pages/glossary.js";
import codes from "@/pages/georgia_codes.js";

export default [
  HTAutonomousVehicle,
  HTAtFault,
  HTPrivatePropertyCrashes,
  HTContributingFactors,
  HTCrashInvestigation,
  HTNarrative,
  HTCommercialMotorVehicles,
  HTOccupantProtection,
  HTFatalCrash,
  HTHitAndRun,
  HTLocation,
  CollisionDetails,
  commercial_motor_vehicles,
  contributing_factors,
  crash_location,
  crash_report_forms,
  crash_specific_information,
  diagrams,
  executive_summary,
  glossary,
  location_identification_tips,
  narrative,
  occupant_information,
  overview,
  property_damage_witness_information,
  reporting_fatal_crashes,
  reporting_motor_vehicle_crashes_with_trains,
  roadway_details,
  submitting_a_crash_report,
  unit_operator_details,
  vehicle_details,
  county_list,
  data,
  rules,
  contactus,
  learning_module,
  codes,
  faq,
];
